import { RescueConstants } from '../store/rescue.constants'

export const rescueSchemas = [
  {
    inputKey: RescueConstants.SET_TYPES,
    isNumber: true,
    type: 'object',
    properties: {
      SET_TYPES: {
        type: 'number',

        minimum: 0.1,
        maximum: 999.9,
      },
    },
    additionalProperties: false,
    required: ['SET_TYPES'],
  },
  {
    inputKey: RescueConstants.SET_HYDRAULICS,
    isNumber: true,
    type: 'object',
    properties: {
      SET_HYDRAULICS: {
        type: 'number',

        minimum: 0.1,
        maximum: 999.9,
      },
    },
    additionalProperties: false,
    required: ['SET_HYDRAULICS'],
  },
  {
    inputKey: RescueConstants.SET_TOOLS,
    isNumber: true,
    type: 'object',
    properties: {
      SET_TOOLS: {
        type: 'number',

        minimum: 0.1,
        maximum: 999.9,
      },
    },
    additionalProperties: false,
    required: ['SET_TOOLS'],
  },
  {
    inputKey: RescueConstants.SET_REHAB,
    isNumber: true,
    type: 'object',
    properties: {
      SET_REHAB: {
        type: 'number',

        minimum: 0.1,
        maximum: 999.9,
      },
    },
    additionalProperties: false,
    required: ['SET_REHAB'],
  },
  {
    inputKey: RescueConstants.SET_ACTIVATIONS,
    isNumber: true,
    type: 'object',
    properties: {
      SET_ACTIVATIONS: {
        type: 'number',

        minimum: 0.1,
        maximum: 999.9,
      },
    },
    additionalProperties: false,
    required: ['SET_ACTIVATIONS'],
  },
  {
    inputKey: RescueConstants.SET_SIZE,
    isNumber: true,
    type: 'object',
    properties: {
      SET_SIZE: {
        type: 'number',

        minimum: 0.1,
        maximum: 999.9,
      },
    },
    additionalProperties: false,
    required: ['SET_SIZE'],
  },
  {
    inputKey: RescueConstants.SET_DATE,
    isNumber: false,
    type: 'object',
    properties: {
      SET_DATE: {
        type: 'string',
        format: 'zoll-now-date',
      },
    },
    additionalProperties: false,
    required: ['SET_DATE'],
    errorMessage: {
      properties: {
        SET_DATE: 'Must be in the format: MM/DD/YY and between 01/01/1950 and 01/01/2050',
      },
    },
  },
  {
    inputKey: RescueConstants.SET_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9](?::[0-5][0-9])?$',
      },
    },
    additionalProperties: false,
    required: ['SET_TIME'],
    errorMessage: {
      properties: {
        SET_TIME: 'Must be in the format: HH:MM and between 00:00 and 23:59',
      },
    },
  },
]

export const rescueSecondsSchemas = [
  {
    inputKey: RescueConstants.SET_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$',
      },
    },
    additionalProperties: false,
    required: ['SET_TIME'],
    errorMessage: {
      properties: {
        SET_TIME: 'Must be in the format: HH:MM:SS and between 00:00:00 and 23:59:59',
      },
    },
  },
]
